import Lookup from 'src/componentes/select2';

const TipoMudancaSolicitacaoGestaoMudancasDocumentoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoMudancaSolicitacaoGestaoMudancasDocumentoLookup"
    clearable={false}
    {...rest}
  />
);

export default TipoMudancaSolicitacaoGestaoMudancasDocumentoLookup;
